export const getGrade = (value) => {
  if (value < 0) return "Pending";
  if (value >= 0 && value <= 33) return "F";
  if (value > 33 && value <= 45) return "D";
  if (value > 45 && value <= 70) return "C";
  if (value > 70 && value <= 90) return "B";
  if (value > 85 && value <= 97) return "A";
  if (value > 97 && value <= 100) return "A*";
};
